// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"About_mainCont__1GqcR","about":"About_about__g1ece","socialIcons":"About_socialIcons__3iSHW","technologies":"About_technologies__1Y80u"};